import { useEffect, useState } from 'react';
import { Camera, Upload, X } from 'lucide-react';

/** Component to upload a single image as base64 data URL. */
export const ImageUpload = ({ value, onChange, label = 'Ajouter une photo', maxSizeMb = 2, testid = 'image-upload' }) => {
  const [error, setError] = useState('');
  const handle = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > maxSizeMb * 1024 * 1024) {
      setError(`Fichier trop volumineux (max ${maxSizeMb}MB)`);
      return;
    }
    setError('');
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(f);
  };
  return (
    <div className="w-full">
      {value ? (
        <div className="relative w-full rounded-[var(--radius)] overflow-hidden border border-[#E2E8F0]" data-testid={`${testid}-preview`}>
          <img src={value} alt="" className="w-full h-40 object-cover" />
          <button
            type="button"
            onClick={() => onChange(null)}
            className="absolute top-2 right-2 h-8 w-8 rounded-full bg-white/90 flex items-center justify-center shadow hover:bg-white"
            data-testid={`${testid}-remove`}
            aria-label="Supprimer l'image"
          >
            <X size={16} />
          </button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center gap-2 w-full h-40 rounded-[var(--radius)] border-2 border-dashed border-[#C7E2FF] bg-[#F2F8FF] text-[#0F5FCC] cursor-pointer hover:bg-[#EAF3FF]">
          <Camera size={22} />
          <span className="text-sm font-medium">{label}</span>
          <input type="file" accept="image/*" className="hidden" onChange={handle} data-testid={testid} />
        </label>
      )}
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
    </div>
  );
};

export const MultiImageUpload = ({ values = [], onChange, max = 5, testid = 'multi-upload' }) => {
  const add = (url) => onChange([...(values || []), url].slice(0, max));
  const remove = (i) => onChange(values.filter((_, idx) => idx !== i));
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {values.map((v, i) => (
          <div key={i} className="relative h-24 rounded-lg overflow-hidden border border-[#E2E8F0]">
            <img src={v} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(i)} className="absolute top-1 right-1 h-6 w-6 rounded-full bg-white/90 flex items-center justify-center" data-testid={`${testid}-remove-${i}`}>
              <X size={12} />
            </button>
          </div>
        ))}
        {values.length < max && (
          <label className="flex flex-col items-center justify-center h-24 rounded-lg border-2 border-dashed border-[#C7E2FF] bg-[#F2F8FF] text-[#0F5FCC] cursor-pointer hover:bg-[#EAF3FF]">
            <Upload size={18} />
            <span className="text-[11px] mt-1">Ajouter</span>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => {
                const f = e.target.files?.[0];
                if (!f) return;
                const reader = new FileReader();
                reader.onload = () => add(reader.result);
                reader.readAsDataURL(f);
              }}
              data-testid={`${testid}-add`}
            />
          </label>
        )}
      </div>
      <p className="text-xs text-slate-500">{values.length}/{max} photos</p>
    </div>
  );
};
